var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProtocol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20.004,
    viewBox: "0 0 20 20.004",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Policy_rules",
    "data-name": "Policy rules",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16154",
    "data-name": "Rectangle 16154",
    width: 15.655,
    height: 2.609,
    transform: "translate(3.174 1)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16155",
    "data-name": "Rectangle 16155",
    width: 15.655,
    height: 2.609,
    transform: "translate(3.174 18.394)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143582",
    "data-name": "Path 143582",
    d: "M22.3,16.486a2.7,2.7,0,0,0,1.3-2.318v-.4l-1.3-.652-1.3.652v.4A2.7,2.7,0,0,0,22.3,16.486Z",
    transform: "translate(-11.303 -6.849)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_143583",
    "data-name": "Path 143583",
    d: "M4.044,5.044V18.09H17.96V5.044Zm6.762.918c.252-.135.248-.074,2.131.87.291.144.239.357.239,1.052A3.434,3.434,0,0,1,11,11.132,3.364,3.364,0,0,1,8.828,7.884C8.828,6.731,8.536,7.1,10.806,5.962ZM6.653,16.35h-.87a.435.435,0,1,1,0-.87h.87a.435.435,0,1,1,0,.87Zm0-1.739h-.87a.435.435,0,0,1,0-.87h.87a.435.435,0,0,1,0,.87Zm0-1.739h-.87a.435.435,0,1,1,0-.87h.87a.435.435,0,1,1,0,.87ZM16.22,16.35H8.393a.435.435,0,1,1,0-.87H16.22a.435.435,0,1,1,0,.87Zm0-1.739H8.393a.435.435,0,0,1,0-.87H16.22a.435.435,0,0,1,0,.87Zm0-1.739H8.393a.435.435,0,1,1,0-.87H16.22a.435.435,0,1,1,0,.87Zm4.527-9.389A.87.87,0,0,0,20.134,2H19.7V3.739h.435a.87.87,0,0,0,.613-.257ZM1,2.87a.87.87,0,0,0,.87.87H2.3V2H1.87A.87.87,0,0,0,1,2.87ZM20.134,19.394H19.7v1.739h.435a.87.87,0,0,0,0-1.739ZM1,20.264a.87.87,0,0,0,.87.87H2.3V19.394H1.87A.87.87,0,0,0,1,20.264Z",
    transform: "translate(0 -0.565)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtocol);
export default __webpack_public_path__ + "static/media/protocol.92df5cf241ee14631fe09999c845164a.svg";
export { ForwardRef as ReactComponent };